import React, { SVGProps } from 'react';

export const DownloadIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 17,
  height = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 17 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17 7.05882H12.1429V0H4.85714V7.05882H0L8.5 15.2941L17 7.05882ZM0 17.6471V20H17V17.6471H0Z"
        fill="currentColor"
      />
    </svg>
  );
};
